export const shadows = {
    styles: {
        none: 'none',
        inset: '0px -1px 0px 0px inset',
        rightInnerBorder: '-1px 0px 0px inset',
        leftInnerBorder: '1px 0px 0px 0px inset',
        broad: '0px 8px 16px',
        narrow: '0px 2px 6px',
        border: '0px 0px 1px',
        borderBottom: '0px 1px 0px',
        medium: '0px 4px 12px',
    },
    alphas: {
        full: '1',
        x0: '0',
        x1: '0.04',
        x2: '0.08',
        x3: '0.12',
        x4: '0.16',
        x5: '0.20',
        x6: '0.24',
        x8: '0.32',
    },
};
//# sourceMappingURL=shadows.js.map